import { utils } from '@digital-commerce/shared-utils'
import { memoizeWith } from 'ramda'

import { getCacheKey } from './cart'

const { _getItems } = utils.cart

export const isRTI = (item) => 'inventory' in item && !!item.inventory

export const isRTIAvailable = (item) => item.inventory?.isUnknown === false

export const isCached = (item) => item.inventory?.isRealTime !== true

export const isOutOfStock = (item) =>
  isRTI(item) &&
  isRTIAvailable(item) &&
  !item.inventory.status.isSellable &&
  !item.inventory.status.inStock

export const getOutOfStockItems = memoizeWith(getCacheKey('get-out-of-stock-items'), (cart) =>
  _getItems(cart).filter(isOutOfStock)
)

export const hasOutOfStockItems = memoizeWith(getCacheKey('has-out-of-stock-items'), (cart) =>
  _getItems(cart).some(isOutOfStock)
)

export const isBackordered = (item) =>
  isRTI(item) &&
  isRTIAvailable(item) &&
  item.inventory.status.isSellable &&
  !item.inventory.status.inStock

export const getBackorderedItems = memoizeWith(getCacheKey('get-backordered-items'), (cart) =>
  _getItems(cart).filter(isBackordered)
)

export const hasBackorderedItems = memoizeWith(getCacheKey('has-backordered-items'), (cart) =>
  _getItems(cart).some(isBackordered)
)

export const getRTISla = (item, locale = 'en') => {
  if (!isRTI(item) || !isRTIAvailable(item)) return null

  const { estimatedShipByDate } = item.inventory?.sla ?? ''
  return new Date(estimatedShipByDate).toLocaleDateString(locale, {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}
